import "@babel/polyfill";
import {initAdapter} from "./initAdapter";

window.initAdapter = initAdapter;
let observable = new Sys.Observable();
if (window.initAdapter) {
    observable.fireEvent("notify:initAdapter.loaded");
}
